import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const RowRoot = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 14px 0;
	border-bottom: 1px solid ${BTTO_PROFILE_COLORS.border};

	&:first-child {
		padding-top: 0;
	}

	&:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}

	@media (max-width: 639px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const RowLabel = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
	flex: 1;
`;

export const RowTitle = styled.span`
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	font-weight: 500;
	line-height: 1.4;
`;

export const RowDescription = styled.span`
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 400;
	line-height: 1.4;
`;

export const RowControl = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
`;

export const RowBadge = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 6px 12px;
	border-radius: 8px;
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 13px;
	font-weight: 500;
`;
